import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Validators } from '../../../../node_modules/@angular/forms';
import { BaseStepComponent } from '../../base';
import { SelectItem } from '../../../../node_modules/primeng/primeng';
import { requiredMaxLength, comparerStringRepeated } from 'app/util/custom.validators';
import { EnderecoTipo } from '../../entity/enumeraveis';

@Component({
  selector: 'endereco',
  templateUrl: './endereco.component.html'
})
export class EnderecoComponent extends BaseStepComponent {
  @Input() listaEndereco: any[];
  @Output() listaEnderecoChange = new EventEmitter<any[]>();
  @Input() label: string;
  @Input() cadastrar: boolean = true;
  @Input() profissional: any;

  enderecoTipo = EnderecoTipo;
  ufOptions: any[];
  listaCidadeFiltro: SelectItem[] = [];
  listaCidade: any[] = [];
  cadastro = this.formBuilder.group({
    tipo_endereco: [null, Validators.required],
    numero: [null, [Validators.required, Validators.min(1), requiredMaxLength(10, true)]],
    bairro: [null, [Validators.required, requiredMaxLength(100, true)]],
    num_cep: [null, [Validators.required, Validators.min(8), comparerStringRepeated]],
    logradouro: [null, Validators.required],
    complemento: [null],
    caixa_postal: [null],
    id_tipo_logradouro: [null, Validators.required],
    id_uf: [null, Validators.required],
    id_cidade: [null, [Validators.required]],
  })
  listaTipoEndereco: any[] = [];
  listaTipoLogradouro: any;

  init() {
    this.service.ListarTodos('uf').subscribe(
      data => {
        this.ufOptions = data
      }
    );
    this.loadListAsEnum(this.listaTipoEndereco, EnderecoTipo);
    this.service.ListarTodos('combo/tipo_logradouro').subscribe(
      data => this.listaTipoLogradouro = data
    );

    this.service.ListarTodos('cidade').subscribe(data => { this.listaCidade = data })
    this.cadastro.get('id_uf').valueChanges.subscribe(value => {
      if (value != null) {
        this.cadastro.get('id_cidade').enable();
        this.service.ListarTodos('cidade', { id_estado: value }).subscribe(data => { this.listaCidadeFiltro = data })
      }
    });
    this.carregarEndereco();
  }
  carregarEndereco() {
    this.cadastro.get('num_cep').valueChanges.subscribe(x => {
      var cep = this.limpaCaracterEspecial(x);
      if (cep.length == 8) {
        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.service.ObterCep('cep/buscaCep', cep).subscribe(endereco => {
          if (endereco != null) {
            this.cadastro.get('id_uf').setValue(endereco.id_uf);
            this.cadastro.get('logradouro').setValue(endereco.logradouro);
            this.cadastro.get('complemento').setValue(endereco.complemento);
            this.cadastro.get('bairro').setValue(endereco.bairro);
            this.cadastro.get('id_cidade').setValue(endereco.id_cidade);
          } else {
            this.cadastro.get('id_uf').setValue(null);
            this.cadastro.get('logradouro').setValue(null);
            this.cadastro.get('complemento').setValue(null);
            this.cadastro.get('bairro').setValue(null);
            this.cadastro.get('id_cidade').setValue(null);
            this.listaCidade = [];
            this.showMsgWarn(`CEP não cadastrado na Base de dados dos Correios.`);
          }
          this.observableUtilPanelDoc.setBlockedPanel(false);
        },
          err => {
            this.observableUtilPanelDoc.setBlockedPanel(false);
            this.showMsg('error', 'Mensagem de Erro', `${err._body}`)
          });
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/Componentes/endereco/endereco.component.ts